<template>
    <div>
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/home' }"
                >首页</el-breadcrumb-item
            >
            <el-breadcrumb-item>详情列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 按时间查询 -->
        <div style="margin: 15px 0">
            <el-input
                class="search_input"
                v-on:input="inputkeyword"
                placeholder="请输入用户昵称、微信单号、套餐名称或景区进行搜索"
                clearable
                v-model="listQuery.key_value"
            ></el-input>
            <el-date-picker
                v-model="daterange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                @change="searchByDate"
                value-format="yyyy-MM-dd"
            >
            </el-date-picker>
        </div>
        <!-- 筛选按钮 -->
        <!-- <div style="margin:15px 0">
      <el-date-picker
        v-model="value"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        @change="time"
      >
      </el-date-picker>
    </div> -->
        <div style="background-color: #fff">
            <div style="background-color: #f7f7f7; text-align: center">
                <!-- 订单标题 -->
                <el-row :gutter="0" style="font-size: 14px">
                    <el-col :span="6">
                        <div
                            class="grid-content bg-purple"
                            style="padding: 10px 0 10px 5px; font-size: 14px"
                        >
                            <span>图片</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div
                            class="grid-content bg-purple"
                            style="padding: 10px 0 10px 5px"
                        >
                            <span>昵称</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div
                            class="grid-content bg-purple"
                            style="padding: 10px 0"
                        >
                            <span>金额</span>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div
                            class="grid-content bg-purple"
                            style="padding: 10px 0"
                        >
                            <span>购买景区</span>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <!-- 订单列表 -->
            <div
                v-for="order in AllOrder"
                :key="order.out_trade_no"
                style="border: 1px solid #e5e5e5; margin: 15px 0"
            >
                <div
                    style="
                        height: 45px;
                        line-height: 45px;
                        background-color: #f7f7f7;
                        font-size: 15px;
                    "
                >
                    <span style="margin: 10px 50px 0 10px; font-weight: 600">{{
                        order.gmttime
                    }}</span
                    ><span>订单号:{{ order.out_trade_no }}</span>
                </div>
                <div>
                    <!-- 订单标题 -->
                    <el-row :gutter="0">
                        <el-col :span="6">
                            <div
                                class="grid-content bg-purple"
                                style="
                                    text-align: center;
                                    border-right: 1px solid #e5e5e5;
                                "
                            >
                                <img
                                    :src="order.area_pic"
                                    alt=""
                                    style="width: 100px; height: 100px"
                                />
                            </div>
                        </el-col>
                        <el-col
                            :span="6"
                            style="border-right: 1px solid #e5e5e5"
                        >
                            <div
                                class="grid-content bg-purple"
                                style="text-align: center; height: 100px"
                            >
                                <span style="line-height: 100px">{{
                                    order.nick_name
                                }}</span>
                            </div>
                        </el-col>
                        <el-col
                            :span="6"
                            style="border-right: 1px solid #e5e5e5"
                        >
                            <div
                                class="grid-content bg-purple"
                                style="text-align: center; height: 100px"
                            >
                                <span style="line-height: 100px">{{
                                    order.cost
                                }}</span>
                            </div>
                        </el-col>
                        <el-col :span="6">
                            <div
                                class="grid-content bg-purple"
                                style="padding: 40px 0; text-align: center"
                            >
                                <span>{{ order.area_name }}</span>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="listQuery.pageindex"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="listQuery.pagesize"
            layout="total,  prev, pager, next, jumper"
            :total="total"
            style="
                text-align: right;
                margin: 0 16px 10px 0;
                border-radius: 20px;
            "
        >
        </el-pagination>
    </div>
</template>

<script>
import qs from "qs";
let input_timer
export default {
    props: {
        pageSize: {
            type: Number,
            default: 10,
        },
    },
    data() {
        return {
            daterange: "",
            AllOrder: [],
            listQuery: {
                pageindex: 1,
                pagesize: 10,
                key_value: undefined,
                start_date: undefined,
                end_date: undefined,
                month_date: undefined,
                area_id: undefined,
                count: false,
            },
            total: 0,
            endDate: "",
            startDate: "",
            time: [],
            isAdmin: false,
        };
    },
    methods: {
        //查询列表
        findScenicSpot() {
            if (this.listQuery.pageindex == 1) {
                this.listQuery.count = true;
            }
            var userData = qs.parse(sessionStorage.getItem("userData"))
            if (userData.role_lx == 2) {
                this.isAdmin = false
                this.listQuery.area_id = userData.area_id
            }else{
                this.isAdmin = true
            }
            if (this.time && this.time.length === 2) {
                this.listQuery.start_date = this.time[0];
                this.listQuery.end_date = this.time[1];
                this.listQuery.month_date = "";
            }
            this.$axios.postRequest({
                    methodUrl: "wechat/getOrderInfo",
                    jsonParam: qs.stringify(this.listQuery)
                }).then(res => {
                    //成功之后处理逻辑
                    this.AllOrder = res.data.list;
                    this.total = res.data.totalcount;
                },
                function (error) {
                    //失败之后处理逻辑
                    console.log(error);
                }
            );
        },
        // 设置默认日期
        settingDate() {
            Date.prototype.format = function (fmt) {
                var o = {
                    "M+": this.getMonth(), //月份
                    "d+": this.getDate(), //日
                    "h+": this.getHours(), //小时
                    "m+": this.getMinutes(), //分
                    "s+": this.getSeconds(), //秒
                    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
                    S: this.getMilliseconds(), //毫秒
                };
                if (/(y+)/.test(fmt)) {
                    fmt = fmt.replace(
                        RegExp.$1,
                        (this.getFullYear() + "").substr(4 - RegExp.$1.length)
                    );
                }
                for (var k in o) {
                    if (new RegExp("(" + k + ")").test(fmt)) {
                        fmt = fmt.replace(
                            RegExp.$1,
                            RegExp.$1.length == 1
                                ? o[k]
                                : ("00" + o[k]).substr(("" + o[k]).length)
                        );
                    }
                }
                return fmt;
            };
            var days = this.listQuery.month_date.split("-");
            console.log(days);
            var date = new Date();
            date.setDate(1);
            date.setMonth(parseInt(days[1]));
            date.setFullYear(days[0]);
            console.log(date.format("yyyy-MM-dd"));
            var year = date.getFullYear();
            var month = date.getMonth();
            var sameMonthFirst = new Date(year, month, "01");
            var beg = sameMonthFirst.format("yyyy-MM-dd");
            this.startDate = beg;
            var nextMonthFirstDay = new Date(year, month, "01");
            var end = new Date(
                nextMonthFirstDay.getTime() - 1000 * 60 * 60 * 24
            ).format("yyyy-MM-dd");
            console.log(end.split("-"));
            var strs = end.split("-");
            this.endDate =
                strs[0] + "-" + (parseInt(strs[1]) + 1) + "-" + strs[2];
            this.daterange = [beg, this.endDate]; //将值设置给插件绑定的数据
            console.log(this.daterange, 63636339663);
        },
        inputkeyword() {
            if (input_timer) {
                clearTimeout(input_timer);
            }
            input_timer = setTimeout(() => {
                this.listQuery.pageindex = 1;
                this.listQuery.area_id = undefined
                this.findScenicSpot();
            }, 500);
        },
        searchByDate(val) {
            this.time = val;
            this.listQuery.pageindex = 1
            this.findScenicSpot();
        },
        // 分页
        handleSizeChange(val) {
            this.listQuery.pagesize = val;
            this.findScenicSpot();
        },
        handleCurrentChange(val) {
            this.listQuery.pageindex = val;
            this.findScenicSpot();
        },
    },
    mounted() {
        this.listQuery.month_date = this.$route.query.the_date;
        if(this.$route.query.area_id){
            this.listQuery.area_id = this.$route.query.area_id
        }
        this.settingDate();
        this.findScenicSpot();
    },
};
</script>

<style>
.search_input {
    width: 25em !important;
    margin-bottom: 1em;
}
</style>



// WEBPACK FOOTER //
// src/components/MonthOrder.vue